module.exports = __webpack_public_path__ + "img/IJR_Mudancas_Fretes_f2.ae81c83a.webp";